/*
 * Gavetas (drawers) da Artisan.
 *
 * Um comportamento so para menu, carrinho e busca: abre, fecha no Esc,
 * fecha no clique fora, prende o foco dentro enquanto aberta e devolve o
 * foco a quem abriu. Trava a rolagem do fundo.
 *
 * O estilo nao mora aqui — mora no CSS de cada gaveta, com os tokens.
 */

const FOCAVEIS = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

class ArtisanGaveta extends HTMLElement {
  connectedCallback() {
    this.painel = this.querySelector('[data-painel]');
    this.fundo = this.querySelector('[data-fundo]');

    this.querySelectorAll('[data-fechar]').forEach((botao) => {
      botao.addEventListener('click', () => this.fechar());
    });

    if (this.fundo) this.fundo.addEventListener('click', () => this.fechar());

    this.addEventListener('keydown', (evento) => {
      if (evento.key === 'Escape') this.fechar();
      if (evento.key === 'Tab') this.prenderFoco(evento);
    });
  }

  abrir(gatilho) {
    this.gatilho = gatilho || null;
    this.setAttribute('aberta', '');
    document.documentElement.style.overflow = 'hidden';

    if (this.gatilho) this.gatilho.setAttribute('aria-expanded', 'true');

    // Espera a transicao comecar antes de mover o foco, senao o Safari
    // rola a pagina para o elemento ainda fora da tela.
    requestAnimationFrame(() => {
      const primeiro = this.querySelector('[data-foco-inicial]') || this.querySelector(FOCAVEIS);
      if (primeiro) primeiro.focus();
    });

    this.dispatchEvent(new CustomEvent('artisan:gaveta-aberta', { bubbles: true }));
  }

  fechar() {
    if (!this.hasAttribute('aberta')) return;

    this.removeAttribute('aberta');
    document.documentElement.style.overflow = '';

    if (this.gatilho) {
      this.gatilho.setAttribute('aria-expanded', 'false');
      this.gatilho.focus();
      this.gatilho = null;
    }

    this.dispatchEvent(new CustomEvent('artisan:gaveta-fechada', { bubbles: true }));
  }

  prenderFoco(evento) {
    const focaveis = Array.from(this.querySelectorAll(FOCAVEIS)).filter(
      (el) => el.offsetParent !== null
    );
    if (focaveis.length === 0) return;

    const primeiro = focaveis[0];
    const ultimo = focaveis[focaveis.length - 1];

    if (evento.shiftKey && document.activeElement === primeiro) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault();
      primeiro.focus();
    }
  }
}

customElements.define('artisan-gaveta', ArtisanGaveta);

/* Liga os botoes do cabecalho as gavetas correspondentes. */
const DESTINOS = {
  menu: 'artisan-gaveta-menu',
  carrinho: 'artisan-gaveta-carrinho',
  busca: 'artisan-busca',
};

document.addEventListener('click', (evento) => {
  const gatilho = evento.target.closest('[data-abrir]');
  if (!gatilho) return;

  const id = DESTINOS[gatilho.dataset.abrir];
  const gaveta = id && document.getElementById(id);
  if (!gaveta) return;

  evento.preventDefault();

  if (gaveta.hasAttribute('aberta')) {
    gaveta.fechar();
  } else {
    gaveta.abrir(gatilho);
  }
});
